module.exports = __webpack_public_path__ + "static/34-e62ca6d3587f0e7f9f4c1156d104b1de.jpg";